import pharmacySubmission from "./submissions/pharmacy_submission.json";
import medicalSubmission from "./submissions/medical_submission.json";
import encounterSubmission from "./submissions/encounter_submission.json";
import validationErrors from "./submissions/validation_errors.json";
import issues from "./submissions/issues.json";

const submissions = {
  submissions: {
    pharmacy: pharmacySubmission,
    pharmacy_encounter: { ...pharmacySubmission, ...encounterSubmission },
    medical: medicalSubmission,
    medical_encounter: { ...medicalSubmission, ...encounterSubmission },
    ...validationErrors,
    ...issues,
  },
};

export default submissions;
